import React, { useMemo, useState } from 'react';
import { Card, Col, Row, Button, Nav, Tab } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { FaCheckCircle } from "react-icons/fa";

const Role = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const columns = useMemo(
        () => [
            {
                Header: "User Name",
                accessor: "userName",
            },
            {
                Header: "User Code",
                accessor: "userCode",
            },
            {
                Header: "Modules",
                accessor: "modules",
            },
            {
                Header: "Permissions",
                accessor: "permissions",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const [data, setData] = useState(
        [
            {
                id: 1,
                userName: 'Kian',
                userCode: '00001',
                modules: 'Activity, Activity Template',
                permissions: 'Read Only, No Access',
                isActive: 1
            },
            {
                id: 2,
                userName: 'Tatvesh',
                userCode: '00002',
                modules: 'Functions, Organiztion Type',
                permissions: 'Read Only, No Access',
                isActive: 0
            },
            {
                id: 3,
                userName: 'Piyush',
                userCode: '00003',
                modules: 'Organiztion Type, Product Category, Product Sub-Category',
                permissions: 'Read Only, Read Only, Read Only',
                isActive: 0
            },
            {
                id: 4,
                userName: 'Hatim',
                userCode: '00004',
                modules: 'Product Category, Product Sub-Category',
                permissions: 'Full Access, Full Access',
                isActive: 1
            },
        ]
    );

    const actions = ['switch', 'edit', 'delete']
    const subActions = []

    const initialValues = {
        userName: '',
        activityPermissions: '',
        activityTemplatePermissions: '',
        documentTypePermissions: '',
        functionsPermissions: '',
        inquiryWorkFlowPermissions: '',
        organiztionTypePermissions: '',
        organizationStagePermissions: '',
        productsPermissions: '',
        productCategoryPermissions: '',
        productSubCategoryPermissions: '',
        sectorsPermissions: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            //setLoadings(true);
            setAddModal(false);
            setEditModal(false);
            //setAddModal(false);
            //setEditModal(false);

            // const formData = new FormData();
            // formData.append('leadName', values.leadName);
            // formData.append('clientType', values.clientType);
            // formData.append('stage', values.stage);
            // formData.append('source', values.source);
            // formData.append('assignee', values.assignee);

            // try {
            //     const res = await postGeneralForms(postData);
            //     toast.success(res.data.message);
            //     setLoadings(false);
            //     setShowModal(false);

            // } catch (error) {
            //     setLoadings(false);
            //     toast.error(error.response?.data?.message || "Error submitting data");
            // }
        },
    });

    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);
        formik.resetForm();
    };

    const handleEdit = (rowData) => {
        setFieldValue('project', rowData.project);
        setFieldValue('productCategory', rowData.productCategory);
        setFieldValue('productSubCategory', rowData.productSubCategory);
        if (rowData.isActive == 1) {
            setIsActive(true);
        }
        else {
            setIsActive(false);
        }

        setEditModal(true);
    };

    const handleDelete = (rowData) => {
    };

    const handleSwitchToggle = (id) => {
        setData(prev => prev.map(data =>
            data.id === id
                ? { ...data, isActive: data.isActive === 1 ? 0 : 1 }
                : data
        ));
    };

    return (
        <>
            <PageTitle titles="Role" active="Role" items={['Home']} />
            <Row>
                <Col sm={12} className="col-12">
                    <Card>
                        <Card.Body className="example1-table">
                            <div className='custompageHed'>
                                <Row>
                                    <Col md={6}>
                                        <div className='pagetitle_hed'>
                                            <h1>Role</h1>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='w-100 d-flex justify-content-end'>
                                            <Button
                                                variant="primary"
                                                onClick={() => setAddModal(true)}
                                            >
                                                Add New
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <Tables
                                columns={columns}
                                data={data}
                                actions={actions}
                                subActions={subActions}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                                onSwitchToggle={handleSwitchToggle}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title="Add New"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Select User</label>
                                <SelectFild
                                    Firstop='Select User'
                                    selectName="userName"
                                    options={[
                                        { name: 'Tatvesh', id: 'Tatvesh' },
                                        { name: 'Kian', id: 'Kian' },
                                        { name: 'Piyush', id: 'Piyush' },
                                    ]}
                                    value={values.userName}
                                    onChange={(selectedOption) => setFieldValue("userName", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.userName && touched.userName && (
                                    <p className="errormsg">{errors.userName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 25 }}>
                                    <label className="form-label">Is Active</label>
                                    <div class="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            id="isActive"
                                            name="isActive"
                                            className="form-control"
                                            autoComplete='off'
                                            checked={isActive}
                                            onChange={() => setIsActive(!isActive)}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='customRowclos'>
                        <Row >
                            <Col md={3} className='rd-none'><h4>Modules</h4></Col>
                            <Col md={3} className='rd-none'><h4>Permissions</h4></Col>
                            <Col md={3} className='rd-none'><h4>Modules</h4></Col>
                            <Col md={3} className='rd-none'><h4>Permissions</h4></Col>

                            <Col md={3}><p>Activity</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="activityPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.activityPermissions}
                                    onChange={(selectedOption) => setFieldValue("activityPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Activity Template</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="activityTemplatePermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.activityTemplatePermissions}
                                    onChange={(selectedOption) => setFieldValue("activityTemplatePermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Currency</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="currencyPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.currencyPermissions}
                                    onChange={(selectedOption) => setFieldValue("currencyPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Document Type</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="documentTypePermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.documentTypePermissions}
                                    onChange={(selectedOption) => setFieldValue("documentTypePermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Functions</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="functionsPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.functionsPermissions}
                                    onChange={(selectedOption) => setFieldValue("functionsPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Inquiry work Flow</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="inquiryWorkFlowPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.inquiryWorkFlowPermissions}
                                    onChange={(selectedOption) => setFieldValue("inquiryWorkFlowPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Organiztion Type</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="organiztionTypePermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.organiztionTypePermissions}
                                    onChange={(selectedOption) => setFieldValue("organiztionTypePermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Organization Stage</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="organizationStagePermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.organizationStagePermissions}
                                    onChange={(selectedOption) => setFieldValue("organizationStagePermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Products</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="productsPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.productsPermissions}
                                    onChange={(selectedOption) => setFieldValue("productsPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Product Category</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="productCategoryPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.productCategoryPermissions}
                                    onChange={(selectedOption) => setFieldValue("productCategoryPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Product Sub-Category</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="productSubCategoryPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.productSubCategoryPermissions}
                                    onChange={(selectedOption) => setFieldValue("productSubCategoryPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>
                            <Col md={3}><p>Sectors</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="sectorsPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.sectorsPermissions}
                                    onChange={(selectedOption) => setFieldValue("sectorsPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={editModal}
                handleClose={() => setEditModal(false)}
                title="Edit Role"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Select User</label>
                                <SelectFild
                                    Firstop='Select User'
                                    selectName="userName"
                                    options={[
                                        { name: 'Tatvesh', id: 'Tatvesh' },
                                        { name: 'Kian', id: 'Kian' },
                                        { name: 'Piyush', id: 'Piyush' },
                                    ]}
                                    value={values.userName}
                                    onChange={(selectedOption) => setFieldValue("userName", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.userName && touched.userName && (
                                    <p className="errormsg">{errors.userName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 25 }}>
                                    <label className="form-label">Is Active</label>
                                    <div class="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            id="isActive"
                                            name="isActive"
                                            className="form-control"
                                            autoComplete='off'
                                            checked={isActive}
                                            onChange={() => setIsActive(!isActive)}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='customRowclos'>
                        <Row >
                            <Col md={3} className='rd-none'><h4>Modules</h4></Col>
                            <Col md={3} className='rd-none'><h4>Permissions</h4></Col>
                            <Col md={3} className='rd-none'><h4>Modules</h4></Col>
                            <Col md={3} className='rd-none'><h4>Permissions</h4></Col>

                            <Col md={3}><p>Activity</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="activityPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.activityPermissions}
                                    onChange={(selectedOption) => setFieldValue("activityPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Activity Template</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="activityTemplatePermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.activityTemplatePermissions}
                                    onChange={(selectedOption) => setFieldValue("activityTemplatePermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Currency</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="currencyPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.currencyPermissions}
                                    onChange={(selectedOption) => setFieldValue("currencyPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Document Type</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="documentTypePermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.documentTypePermissions}
                                    onChange={(selectedOption) => setFieldValue("documentTypePermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Functions</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="functionsPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.functionsPermissions}
                                    onChange={(selectedOption) => setFieldValue("functionsPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Inquiry work Flow</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="inquiryWorkFlowPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.inquiryWorkFlowPermissions}
                                    onChange={(selectedOption) => setFieldValue("inquiryWorkFlowPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Organiztion Type</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="organiztionTypePermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.organiztionTypePermissions}
                                    onChange={(selectedOption) => setFieldValue("organiztionTypePermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Organization Stage</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="organizationStagePermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.organizationStagePermissions}
                                    onChange={(selectedOption) => setFieldValue("organizationStagePermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Products</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="productsPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.productsPermissions}
                                    onChange={(selectedOption) => setFieldValue("productsPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Product Category</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="productCategoryPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.productCategoryPermissions}
                                    onChange={(selectedOption) => setFieldValue("productCategoryPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>

                            <Col md={3}><p>Product Sub-Category</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="productSubCategoryPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.productSubCategoryPermissions}
                                    onChange={(selectedOption) => setFieldValue("productSubCategoryPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>
                            <Col md={3}><p>Sectors</p></Col>
                            <Col md={3}>
                                <SelectFild
                                    Firstop='Select Permissions'
                                    selectName="sectorsPermissions"
                                    options={[
                                        { name: 'No Access', id: 'No Access' },
                                        { name: 'Read Only', id: 'Read Only' },
                                        { name: 'Full Access', id: 'Full Access' },
                                    ]}
                                    value={values.sectorsPermissions}
                                    onChange={(selectedOption) => setFieldValue("sectorsPermissions", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Update</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>
        </>
    )
}

export default Role